var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-4"},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"heading text-center",staticStyle:{"font-weight":"200 !important"}},[_vm._t("default")],2),_c('span',{staticClass:"heading-underscore"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }